import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

const EMPTY_ARRAY: any[] = [];

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		rowActions: [
			{
				name: 'View Detail',
				id: 'viewDetail',
				isEnabled: () =>
					hasPermission({
						entity: DASHBOARD_RESOURCES.configImpact,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.configImpact]?.viewDetail,
						appName,
						configPageName: PAGE_NAMES.dashboard
					})
			},
			{
				name: 'Analyze Impact',
				id: 'analyze',
				isEnabled: () =>
					hasPermission({
						entity: DASHBOARD_RESOURCES.configImpact,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.configImpact]?.analyzeImpact,
						appName,
						configPageName: PAGE_NAMES.dashboard
					})
			}
		],
		bulkActions: EMPTY_ARRAY,
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => false
		}
	};
};
